import {LatLng} from "leaflet";
import {IPointTemplatesSingleVoyage} from "@containers/singleVoyage/pointTemplates/types";
import {getLatLngFromPointGeomCoordinates} from "@helpers/geoJson/getLatLngFromPointGeomCoordinates";

export interface IPointTemplateOption {
	pointTemplate: IPointTemplatesSingleVoyage
	/** metres from origin, null when there is no origin to measure from */
	distance: number | null
}

/**
 * Orders waypoint templates for the picker. With an origin - normally the last stop already
 * added to the route - the nearest ones come first, which is what makes a list of 1500
 * usable. Without an origin the original order is kept.
 */
export const buildPointTemplateOptions = ({pointTemplates, origin}: {
	pointTemplates: IPointTemplatesSingleVoyage[]
	origin?: { lat: number, lng: number } | null
}): IPointTemplateOption[] => {
	if (!pointTemplates?.length) {
		return []
	}

	if (!origin?.lat || !origin?.lng) {
		return pointTemplates.map((pointTemplate) => ({pointTemplate, distance: null}))
	}

	const originLatLng = new LatLng(origin.lat, origin.lng)

	return pointTemplates
		.map((pointTemplate) => {
			const {lat, lng} = getLatLngFromPointGeomCoordinates(pointTemplate.geom)
			return {
				pointTemplate,
				distance: originLatLng.distanceTo(new LatLng(lat, lng)),
			}
		})
		.sort((a, b) => a.distance - b.distance)
}
